import { useAiAnswersPageContext } from "@contexts/main/ai_answers_page_context"
import { useSubscription } from "@apollo/client"
import { useQueryClient } from "@tanstack/react-query"
import createdAiMessage from "__generated__/queries/subscriptions/createdAiMessage"
import updatedAiMessage from "__generated__/queries/subscriptions/updatedAiMessage"
import {
  AiMessageEventResponse,
  AiMessages,
  AiMessageSubscriptionInput
} from "__generated__/graphql"
import {
  applyCreatedAiMessage,
  applyUpdatedAiMessage
} from "@pages/main/ai_answers/aiMessagesRealtime.utils"

/** Live-updates the AI logs sidebar list and any open conversation thread via GraphQL subscriptions (redisPubSub-backed on the backend). */
export default function useAiMessagesRealtime(
  onUpdated?: (message: AiMessages) => void
) {
  const queryClient = useQueryClient()
  const { filters } = useAiAnswersPageContext()
  const token = localStorage.getItem("authToken") ?? ""

  const variables: { data: AiMessageSubscriptionInput } = {
    data: {
      token,
      customer: filters.customerId || undefined
    }
  }

  useSubscription<{ createdAiMessage: AiMessageEventResponse }>(
    createdAiMessage,
    {
      variables,
      skip: !token,
      onData: ({ data }) => {
        const incoming = data.data?.createdAiMessage?.data as
          | AiMessages
          | undefined
        if (!incoming?._id) return
        applyCreatedAiMessage(queryClient, incoming)
      }
    }
  )

  useSubscription<{ updatedAiMessage: AiMessageEventResponse }>(
    updatedAiMessage,
    {
      variables,
      skip: !token,
      onData: ({ data }) => {
        const incoming = data.data?.updatedAiMessage?.data as
          | AiMessages
          | undefined
        if (!incoming?._id) return
        applyUpdatedAiMessage(queryClient, incoming)
        onUpdated?.(incoming)
      }
    }
  )
}
